import { render, staticRenderFns } from "./epro-create.vue?vue&type=template&id=1386317f&scoped=true&"
import script from "./epro-create.vue?vue&type=script&lang=js&"
export * from "./epro-create.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./epro-create.vue?vue&type=style&index=1&id=1386317f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386317f",
  null
  
)

component.options.__file = "epro-create.vue"
export default component.exports